<template>
  <b-form-group
    :label="$t('users.form.status')"
    label-for="status"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('users.form.status')"
      rules="required"
    >
      <v-select
        v-model="dataItem.status"
        :options="statuses"
        label="title"
        :reduce="status => status.id"
        :placeholder="$t('users.form.status')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'UserType',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    statuses() {
      return [{
        id: '1',
        title: this.$t('common.active'),
      }, {
        id: '0',
        title: this.$t('common.passive'),
      }]
    },
    dataItem() {
      return this.$store.getters['users/dataItem']
    },
  },
}
</script>
